export default [
  {
    path: '/customer-success/painel',
    name: 'customer-success-painel',
    component: () => import('@/views/customer-success/painel/PainelCustomerSuccess.vue'),
    meta: {
      pageTitle: 'Painel Customer Success',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/customer-success/stores',
    name: 'customer-success-stores',
    component: () => import('@/views/customer-success/stores/stores.vue'),
  },
  {
    path: '/customer-success/admins',
    name: 'customer-success-admin',
    component: () => import('@/views/customer-success/users/admins.vue'),
  },
]
